import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerAccountCategoryForm from '../containers/PlannerAccountCategoryFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerAccountCategoryEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerAccountCategoryEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_account_category_route_edit')} />
          <PlannerAccountCategoryForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerAccountCategoryEditScreen;

Logger.log('silly', `PlannerAccountCategoryEditScreen loaded.`);